'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _row = require('antd/lib/row');

var _row2 = _interopRequireDefault(_row);

var _col = require('antd/lib/col');

var _col2 = _interopRequireDefault(_col);

var _checkbox = require('antd/lib/checkbox');

var _checkbox2 = _interopRequireDefault(_checkbox);

require('antd/lib/row/style');

require('antd/lib/col/style');

require('antd/lib/checkbox/style');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CheckboxsWidget = function CheckboxsWidget(props) {
  console.log('CheckboxsWidget: ', props.value);
  return _react2.default.createElement(
    _checkbox2.default.Group,
    { onChange: props.onChange, value: props.value },
    _react2.default.createElement(
      _row2.default,
      null,
      props.options.enumOptions.map(function (_ref) {
        var label = _ref.label,
            value = _ref.value;
        return _react2.default.createElement(
          _col2.default,
          { key: value, span: 8 },
          _react2.default.createElement(
            _checkbox2.default,
            { value: value },
            label
          )
        );
      })
    )
  );
};

CheckboxsWidget.defaultProps = {
  value: []
  // disabled: false,
};

CheckboxsWidget.propTypes = {
  value: _propTypes2.default.array,
  // disabled: PropTypes.bool,
  // required: PropTypes.bool.isRequired,
  options: _propTypes2.default.object.isRequired,
  onChange: _propTypes2.default.func.isRequired
};

exports.default = CheckboxsWidget;


//////////////////
// WEBPACK FOOTER
// ./node_modules/slide-new-toolkit/dist/Form/Widgets/CheckboxesWidget/index.js
// module id = 960
// module chunks = 0